









import {Component} from "vue-property-decorator"
import Vue from "vue"
import JdiContent from "@/components/JdiContent.vue"

import JdiHeading from "@/components/JdiHeading.vue"
import JdiStatus from "@/components/JdiStatus.vue"
import JdsButton from "@/design-system/components/Button/JdsButton.vue"

@Component({
    components: {JdsButton, JdiStatus, JdiHeading, JdiContent}
})
export default class TextProvider extends Vue {
}
